import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BellOutlined = _resolveComponent("BellOutlined")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: "/",
    class: "indexlayout-top-message"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BellOutlined, { style: { fontSize: '16px' } }),
      _createVNode(_component_a_badge, {
        class: "indexlayout-top-message-badge",
        count: _ctx.message,
        numberStyle: { boxShadow: 'none', height: '15px', 'line-height': '15px' }
      }, null, 8, ["count"])
    ]),
    _: 1
  }))
}